import type { CheckoutOrderStatusResponse, CheckoutsOrdersRequest, CheckoutsOrdersResponse, ConfirmCheckoutOrderRequest, ConfirmCheckoutOrderResponse, SurveyFormRequest, UserCheckoutOptionsResponse } from '@/types/checkout';
import type { ErrorResponse } from '@/types/common';

export const postCheckoutsOrdersAPI = (payload: Partial<CheckoutsOrdersRequest>) => {
	return useRequest<CheckoutsOrdersResponse, ErrorResponse>(CHECK_OUTS_ORDERS_ENDPOINT, REQUEST_METHOD.POST, {
		...payload,
	});
};

export const getUserCheckoutOptionsAPI = (userId: number, eventId: number) => {
	const endPoint = `${USERS_ENDPOINT}/${userId}/account/checkout-options`;
	return useRequest<UserCheckoutOptionsResponse, ErrorResponse>(endPoint, REQUEST_METHOD.GET, {}, {
		eventId,
	});
};

export const patchCheckoutOrderBuyerInfoByOrderIdAPI = (orderId: string, payload: Partial<CheckoutsOrdersRequest>) => {
	return useRequest<{}, ErrorResponse>(`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/buyer-info`, REQUEST_METHOD.PATCH, payload);
};

export const postConfirmCheckoutsOrdersAPI = (orderId: string, payload: ConfirmCheckoutOrderRequest) => {
	return useRequest<ConfirmCheckoutOrderResponse, ErrorResponse>(`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/confirm`, REQUEST_METHOD.POST, payload);
};

export const getCheckoutOrdersStatusAPI = (orderId: string) => {
	return useRequest<CheckoutOrderStatusResponse, ErrorResponse>(`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/status`, REQUEST_METHOD.GET);
};

export const patchSurveyFormByOrderIdAPI = (orderId: string, payload: SurveyFormRequest) => {
	return useRequest<{}, ErrorResponse>(`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/survey`, REQUEST_METHOD.PATCH, payload);
};